import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Home = () => {
    const navigate = useNavigate()
    const userType = sessionStorage.getItem('user_type')

    
    useEffect(() => {
        if(sessionStorage.getItem('IdToken')  !== null){
            userType === 'monitor-user'?navigate('/manage-dashboard'):navigate('/alerts-notifications')
        } else{
            navigate('/')
        }
    }, [])

    return (
        <div></div>
    )
}

export default Home